module.exports = __webpack_public_path__ + "img/chat-square-text-fill.8eff4469.svg";